const prefix = 'LIFE_SIMULATOR';

export const SET_LOADING = `${prefix}/SET_LOADING`;
export const POPULATE_CONTEXT = `${prefix}/POPULATE_CONTEXT`;
export const POPULATE_SCENARIO_DETAILS = `${prefix}/POPULATE_SCENARIO_DETAILS`;
export const POPULATE_GRAPH_INTERVAL = `${prefix}/POPULATE_GRAPH_INTERVAL`;
export const POPULATE_SEARCHED_CAREERS = `${prefix}/POPULATE_SEARCHED_CAREERS`;
export const POPULATE_SCENARIO_LIST = `${prefix}/POPULATE_SCENARIO_LIST`;
export const CACHE_UPDATE = `${prefix}/CACHE_UPDATE`;
export const SET_OPEN_PANEL = `${prefix}/SET_OPEN_PANEL`;
export const POPULATE_SEARCHED_COLLEGES = `${prefix}/POPULATE_SEARCHED_COLLEGES`;

export const PANELS = {
  CAREER: 'CAREER',
  EDUCATION_GOAL: 'EDUCATION_GOAL',
  EDUCATION_FINANCES: 'EDUCATION_FINANCES',
  FAMILY: 'FAMILY',
  LIFESTYLE: 'LIFESTYLE',
  LOCATION: 'LOCATION',
};

export const AVERAGE_SCHOOL_COST = 23091;
export const NON_DEGREE_SEEKING_PK = 5;
export const MAX_CHILD_COUNT = 15;
export const DOLLAR_LIMIT = 2000000000;
export const DOLLAR_LIMIT_MESSAGE = 'Number must be less than 2,000,000,000';

export const ENTER_KEY_CODE = 69;

export const LOAN_TERM_DEFAULT = 10;
export const LOAN_INTEREST_RATE_DEFAULT = '0.03';
